import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

import SectionTitle from "./SectionTitle";

import { type EventScheduleItem } from "@/schemas/events/EventSchedule";
import { themes } from "@/Components/Styling/themeConfigs";

interface Props {
  schedule: EventScheduleItem[];
}

function EventSchedule({ schedule }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const iconColor = currentTheme.icon.color;
  const iconSize = currentTheme.icon.size.web.medium;

  const styles = StyleSheet.create({
    container: {
      alignContent: "center",
    },
    scheduleList: {
      gap: 12,
    },
    card: {
      backgroundColor: "#FFFFFF",
      borderRadius: 12,
      padding: 16,
    },
    cardContent: {
      flexDirection: "row",
      gap: 16,
    },
    timeSection: {
      width: 100,
      flexDirection: "row",
      alignItems: "center",
      gap: 4,
    },

    timeText: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
    detailsSection: {
      flex: 1,
    },
    title: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
      marginBottom: 4,
    },
    description: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
      marginBottom: 8,
      lineHeight: 20,
    },
  });

  return (
    <View style={styles.container}>
      <SectionTitle title="Schedule" />
      {/* Schedule Items */}
      <View style={styles.scheduleList}>
        {schedule.map((event, index) => (
          <View key={index} style={styles.card}>
            <View style={styles.cardContent}>
              {/* Time Section */}
              <View style={styles.timeSection}>
                <MaterialIcons
                  name="access-time"
                  size={iconSize}
                  color={iconColor}
                />
                <Text style={styles.timeText}>{event.startDateTime}</Text>
              </View>

              {/* Schedule Details */}
              <View style={styles.detailsSection}>
                <Text style={styles.title}>{event.title}</Text>
                <Text style={styles.description}>{event.description}</Text>
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
}

export default EventSchedule;
